import customfn from "@/_functions.js";

$(function () {

    $(document).on('click', 'button.start-create-access-group', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');

        customfn.getModal(url, $(this));
    })

    $(document).on('click', 'button.save-basic-access-rule', function(ev){
        ev.preventDefault();

        // Get the ur
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = $(this).closest('.modal-content').find('form#access-basic-data').serialize();

        customfn.postModal(url,formFields);
    });


    $(document).on('click', 'button.save-spaces-groups-access-rule', function(ev){
        ev.preventDefault();

        // Get the ur
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = [];
        var spacesVals = [];
        $($(document).find('input.spaces-checkboxes:checked')).each(function() {
            spacesVals.push($(this).val());
        });
        var groupsVals = [];
        $($(document).find('input.groups-checkboxes:checked')).each(function() {
            groupsVals.push($(this).val());
        });
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "inventory", value: spacesVals});
        formFields.push({name: "groups", value: groupsVals});

        customfn.postModal(url,$.param(formFields));
    });

    $(document).on('click', 'button.access-group.previous-step', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    $(document).on('click', 'a.edit-role', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url);
    })

    // Save the roles
    $(document).on('click', 'button.save-items-access-rule2', function(ev){
        ev.preventDefault();

        //// Get the url
        var url = $(this).attr('href');

        // Get the formfields
        var formFields = $(this).closest('form').serialize();

        customfn.postModal(url,formFields);
    });

    // Save the roles
    $(document).on('click', 'button.save-items-access-rule', function(ev){
        ev.preventDefault();
        // Get the url
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = $(this).closest('.modal-content').find('form#access-items').serialize();
        customfn.postModal(url,formFields);
    });

    // Remove the items from the access group
    $(document).on('click', 'a.delete-access-item', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = $(this).closest('form.delete-item-form').serialize();

        customfn.postModal(url,formFields);
    });

    // Save the access group
    $(document).on('click', 'button.save-access-rule', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = '';
        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        customfn.postModal(url, $.param(formFields));
    });

    $(document).on('change', 'select#timeframes', function(ev){
        ev.preventDefault();
        var type = $(this).val();

        customfn.setTimeFrameOverview(type, true);
    });

    $(document).on('blur', 'form#access-basic-data input.end_date', function(ev){
        ev.preventDefault();

        $(document).find('form#access-basic-data input.any_date').removeAttr('checked').prop('checked', false);
    });

    $(document).on('change', 'input.any_date', function(ev){
        ev.preventDefault();
        // determine form
        var formName = $(this).closest('form').attr('id');
        if($(this).is(':checked')){
            $(document).find('form#' + formName +' input.end_date').val('');
        }
        else{
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();
            $(document).find('form#' + formName +' input.end_date').val(dd+'-'+mm+'-'+yyyy);
        }
    });

    $(document).on('keyup', 'form#access-basic-data input', function(ev){
        ev.preventDefault();
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });
    $(document).on('click', '.modal-body .spaces-checkboxes', function(ev){
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });
    $(document).on('click', '.modal-body .groups-checkboxes', function(ev){
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });
    $(document).on('click', '.modal-body .roles-checkboxes', function(ev){
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });
    $(document).on('click', '.modal-body .companies-checkboxes', function(ev){
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });
    $(document).on('click', '.modal-body .users-checkboxes', function(ev){
        $(this).closest('.form-group').removeClass('is-invalid').find('.invalid-feedback').hide();
    });

    // Delete a acess group (get the modal)
    $(document).on('click', 'button.delete-item', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');

        customfn.getModal(url, undefined, {keyboard: false, backdrop: 'static'});
    });

    //Realy delete the access group
    $(document).on('click', 'button.delete-access-rule', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var formFields = $(this).closest('form').serialize();

        // Remove the cancel button
        $(document).find('button.cancel-button').hide();

        // Show the spinner
        $(document).find('.delete-div').removeClass('d-none');
        // Hide the message
        $(document).find('.show-message').addClass('d-none');

        customfn.postModal(url, formFields);
    });

    $(document).on('click', 'a.edit-access-group', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var a = $(this);
        customfn.getModal(url, $(this), {}, function(){
            if(a.parent().parent().hasClass('dropdown-menu')) {
                var d = "disabled";
                a.closest('.button-dropdown').find('.dropdown-toggle').each(function() {
                    customfn.resetButtonLoadingState(this);
                });
                a.closest('.button-dropdown').find('.dropdown-toggle').removeClass(d).removeAttr(d).prop(d, false);
            }
        });
    })

    $(document).on('click', '.save-modal-form', function(ev) {
        ev.preventDefault();
        // Get the ur
        var url = $(this).attr('href');
        // Get the formfields
        var formFields = $(document).find('#modal-wrapper .modal-body form:first').serialize();
        customfn.postModal(url,formFields);
    });

    $(document).on('click', '.load-inventory-access-section', function(ev) {
        ev.preventDefault();
        var btn = $(this),
            url = btn.attr('href'),
            section = btn.closest('table'),
            icon = $('<span></span>');
        icon.addClass('spinner visible anim-spin');
        btn.after(icon);
        $.get(url, function (data) {
            if (typeof data.html !== 'undefined') {
                section.find('tbody').html(data.html);
            } else {
                customfn.resetButtonLoadingState(btn);
                btn.parent().find('.spinner').remove();
            }
        }).fail(function(){
            customfn.resetButtonLoadingState(btn);
            btn.parent().find('.spinner').remove();
        });
    });

    if ($('.load-inventory-access-section').length > 0) {
        $('.load-inventory-access-section').trigger('click');
    }

});


